import { useNavigate } from "react-router-dom";
import "./GridStyles.scss";
import { useSimulationParams } from "../../shared/hooks/useSimulationParams";

interface Stat {
  icon: string;
  label: string;
  value: string;
}

interface CardData {
  title: string;
  stats: Stat[];
  tableName: string;
}

interface GridContainerProps {
  data: CardData[];
  selectedDataset: string; 
}

function GridContainer({ data, selectedDataset }: GridContainerProps) {
  const navigate = useNavigate();
  const { createLink } = useSimulationParams();

  const handleCardClick = (tableName: string) => {
    navigate(createLink("/view-all-attributes"), {
      state: { tableName, selectedDataset }, 
    });
  };

  return (
    <div className="grid-container-wrap row">
      {data.map((card, index) => (
        <div
          className="grid-container-wrap__card-wrap col-md-4"
          key={index}
          onClick={() => handleCardClick(card.tableName)}
          style={{ cursor: "pointer" }}
        >
          <div className="grid-container-wrap__card">
            <div className="grid-container-wrap__card__label">{card.title}:</div>
            {card.stats.map((stat, i) => (
              <div className="grid-container-wrap__card__details" key={i}>
                <div className="grid-container-wrap__card__details__left">
                  <img src={stat.icon} alt="icon" />
                  <span>{stat.label}</span>
                </div>
                <div className="grid-container-wrap__card__details__right">
                  {stat.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default GridContainer;
